'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useLookupsStore } from '@repo/store/useLookupsStore'
import { useNewMatterStore } from '@repo/store/useNewMatterStore'

export const BranchSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  size = 'small',
  required,
  errors = {}
}) => {
  const { fetchBranches, branches } = useLookupsStore()
  const { branch } = useNewMatterStore()
  const [options, setOptions] = useState(testData || branches || [])
  const [selectedValue, setSelectedValue] = useState(value)

  useEffect(() => {
    if (testData) return
    setOptions(branches || [])
  }, [testData, branches])

  useEffect(() => {
    if (testData || branches?.length) return
    fetchBranches()
  }, [testData, branches, fetchBranches])

  useEffect(() => {
    // Check if value is a number and update the selectedValue accordingly
    if (branch) {
      setSelectedValue(branch)
    } else if (typeof value === 'number') {
      const selectedOption = options.find((option) => option.branchId === value)
      if (selectedOption) {
        setSelectedValue(selectedOption)
      }
    } else {
      setSelectedValue(value)
    }
  }, [value, options, branch])

  return (
    <div data-testid="BranchSelect" style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%' }}>
      <ReactSelectMenu
        label="Branch"
        onChange={(newVal) => {
          onChange(newVal)
          setSelectedValue(newVal)
        }}
        labelKey="description"
        valueKey="branchId"
        items={options}
        value={selectedValue}
        searchable
        idLabelKey="branchId"
        showIdInResults={false}
        name="branch"
        size={size}
        required={required}
        errors={errors}
      />
    </div>
  )
}

BranchSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  size: PropTypes.string,
  required: PropTypes.bool,
  errors: PropTypes.object
}
